var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF3EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7581 27.0273V25.3607C26.7581 24.4766 26.4069 23.6288 25.7818 23.0037C25.1567 22.3785 24.3089 22.0273 23.4248 22.0273H16.7581C15.8741 22.0273 15.0262 22.3785 14.4011 23.0037C13.776 23.6288 13.4248 24.4766 13.4248 25.3607V27.0273",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0921 18.694C21.9331 18.694 23.4255 17.2016 23.4255 15.3607C23.4255 13.5197 21.9331 12.0273 20.0921 12.0273C18.2512 12.0273 16.7588 13.5197 16.7588 15.3607C16.7588 17.2016 18.2512 18.694 20.0921 18.694Z",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVerification);
export default __webpack_public_path__ + "static/media/profileVerification.4ab961cbc9fa6725455a63da4e83552e.svg";
export { ForwardRef as ReactComponent };